/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Strip_UrlsInputs */

const en_dialog_text_to_audio_strip_urls = /** @type {(inputs: Dialog_Text_To_Audio_Strip_UrlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strip URLs`)
};

const es_dialog_text_to_audio_strip_urls = /** @type {(inputs: Dialog_Text_To_Audio_Strip_UrlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar URLs`)
};

/**
* | output |
* | --- |
* | "Strip URLs" |
*
* @param {Dialog_Text_To_Audio_Strip_UrlsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_strip_urls = /** @type {((inputs?: Dialog_Text_To_Audio_Strip_UrlsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Strip_UrlsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_strip_urls(inputs)
	return en_dialog_text_to_audio_strip_urls(inputs)
});